<h2 mat-dialog-title>{{ 'login.recovery_password' | translate }}</h2>

<mat-dialog-content class="mat-typography" [formGroup]="recoveryForm">
  <div class="d-flex flex-column gap-4">
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>{{ 'login.username' | translate }}</mat-label>
      <input
        matInput
        type="text"
        [placeholder]="'login.username' | translate"
        id="username"
        formControlName="username"
        required
      />
      <mat-error *ngIf="recoveryForm.hasError('required', 'username')">
        {{ 'login.enter_username' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>{{ 'login.email' | translate }}</mat-label>
      <input
        matInput
        type="text"
        [placeholder]="'login.email' | translate"
        id="email"
        formControlName="email"
        required
      />
      <mat-error *ngIf="recoveryForm.hasError('required', 'email')">
        {{ 'login.enter_email' | translate }}
      </mat-error>
    </mat-form-field>
  </div>
</mat-dialog-content>

<div class="d-flex justify-content-end align-item-center gap-2">
  <button mat-flat-button mat-dialog-close>{{ 'common.close' | translate }}</button>
  <button mat-flat-button color="primary" (click)="recovery()">{{ 'login.recovery' | translate }}</button>
</div>
